import { ThemeProps } from 'styled-components';
import { css } from '../../common.styles';
import { Theme } from './theme';
import { SessionStoredItem } from '../../storage/session-stored-item';

type ValueParameter = number | string;

const direction = new SessionStoredItem<string>('420', 'direction');

const paramToCss = (value: ValueParameter) => (typeof value === 'number' ? `${value}px` : value);
export const isLTR = (p?: ThemeProps<Theme>) => {
  return (direction.item || 'ltr') === 'ltr';
};
const inlineStyles = (prop: 'margin' | 'padding' | 'inset', start: string, end: string) => css`
  ${prop}-inline-start: ${start};
  ${prop}-inline-end: ${end};
`;

export const marginInline = (start: ValueParameter, end: ValueParameter) => {
  const startValue = paramToCss(start);
  const endValue = paramToCss(end);
  return css`
    ${(p) =>
      isLTR(p)
        ? `
      margin-left: ${startValue};
      margin-right: ${endValue};
    `
        : `
      margin-left: ${endValue};
      margin-right: ${startValue};
    `}
    ${inlineStyles('margin', startValue, endValue)}
  `;
};

export const paddingInline = (start: ValueParameter, end: ValueParameter) => {
  const startValue = paramToCss(start);
  const endValue = paramToCss(end);
  return css`
    ${(p) =>
      isLTR(p)
        ? `
      padding-left: ${startValue};
      padding-right: ${endValue};
    `
        : `
      padding-left: ${endValue};
      padding-right: ${startValue};
    `}
    ${inlineStyles('padding', startValue, endValue)}
  `;
};

export const insetInline = (start: ValueParameter = 'auto', end: ValueParameter = 'auto') => {
  const startValue = paramToCss(start);
  const endValue = paramToCss(end);
  return css`
    ${(p) =>
      isLTR(p)
        ? `
      left: ${startValue};
      right: ${endValue};
    `
        : `
      left: ${endValue};
      right: ${startValue};
    `}
    ${inlineStyles('inset', startValue, endValue)}
  `;
};

export const insetInlineForSlider = (start: ValueParameter = 'auto', end: ValueParameter = 'auto') => {
  const startValue = paramToCss(start);
  const endValue = paramToCss(end);
  return css`
    ${(p) =>
      isLTR(p)
        ? `
      left: ${startValue};
      right: ${endValue};
      inset-inline-start: ${start};
      inset-inline-end: ${end};
    `
        : `
      left: ${endValue};
      right: ${startValue};
      inset-inline-start: ${end};
      inset-inline-end: ${start};
    `}
  `;
};

export const textAlignInline = (ltrDirection: 'left' | 'right') => {
  const rtlDirection = ltrDirection === 'left' ? 'right' : 'left';
  return css`
    ${(p) =>
      isLTR(p)
        ? `
      text-align: ${ltrDirection};
    `
        : `
      text-align: ${rtlDirection};
    `}
  `;
};

export const borderInlineStart = (value: string) => {
  return css`
    ${(p) =>
      isLTR(p)
        ? css`
            border-left: ${value};
          `
        : css`
            border-right: ${value};
          `}

    border-inline-start: ${value};
  `;
};

export const borderInlineEnd = (value: string) => {
  return css`
    ${(p) =>
      isLTR(p)
        ? css`
            border-right: ${value};
          `
        : css`
            border-left: ${value};
          `}

    border-inline-end: ${value};
  `;
};
